import ReactDOM from "react-dom/client";
import "normalize.css";
import { initial } from "@/utils/initial";
import App from "./index.tsx";
import "intersection-observer";

// 宿主登录态的对齐（applyHostLoginState）已收拢进 initial() 的第一行，三个应用入口统一接入
initial({ appName: "par-marketing" });

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
